export default __webpack_public_path__ + "static/media/margaritas.cc1a618b.jpg";